// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Sidemenu/PopularCollections/PopularCollections.css
// module id = 443
// module chunks = 0